<script lang="ts" setup>
import { type Image } from '~/types/types';
  
    const props = defineProps<{
        buttonLabel: string,
        filePath: {
          url: string,
          title: string
        }
        title: string,
        image: Image
    }>();
</script>
<template>
    <div class="where-we-build container-fluid bg-secondary">
      <div class="container-xl">
        <div class="image-container mb-5">
          <div class="main-image h-100" :style="`background: url('${image?.node?.mediaItemUrl}')`">
          </div>
          <div class="d-md-block d-none plus-button" data-bs-toggle="modal" data-bs-target="#image-modal">
            <NuxtImg height="30" width="auto" loading="lazy" src="plus.svg" alt="Browse"/>
          </div>
        </div>
        
        <div class="content-section">
          <h1 class="title text-dark-2">{{ title }}</h1>
          <a :href="`${filePath?.url || '/'}`" class="browse-button btn btn-secondary rounded-pill" download target="_blank" :aria-label="filePath?.title">
            {{ buttonLabel }}
          </a>
        </div>
        
        <div class="divider"></div>
      </div>
  
      <!-- Modal -->
      <div 
        class="modal fade"
        tabindex="-1" 
        aria-labelledby="imageModalLabel"
        aria-hidden="true"
        id="image-modal"
      >
        <div class="modal-dialog modal-xl modal-dialog-centered wwb-modal">
          <div class="modal-content">
            <div class="modal-body p-4">
                
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
                <div class="modal-image">
                    <NuxtImg v-if="image?.node?.mediaItemUrl" loading="lazy" :src="image?.node?.mediaItemUrl" format="webp" :srcset="image?.node?.srcSet"
                    :quality="80"/>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>